import React, {Component} from 'react';
import { connect } from 'react-redux';
import Moment from "react-moment";
import 'moment/locale/ro';
import imgProfile from '../../../FO/resources/img/user-account-icon.png';
import { API_URL } from "../../../SHARED/config/apiEndpoints";


class NewsAuthor extends Component {

    render() {
        return (
            <div className="news-auhor clearfix">
                <div className="lefty">
                    <img alt={'Autor'} className="img-fluid rounded-circle" src={this.props.image !== '' ? API_URL + this.props.image : imgProfile}/>
                </div>
                <div className="righty float-left">
                    <div className="news-author-date text-muted">
                        <Moment format="DD MMMM YYYY" locale="ro" unix>
                            {this.props.createdDate}
                        </Moment>
                    </div>   
                    <div className="news-auhor-name">Scris de <span className="comment-name">{this.props.name}</span></div>
                </div>
            </div>  
        );
    }
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps,{})(NewsAuthor);


// WEBPACK FOOTER //
// ./src/SHARED/components/newsauthor/newsauthor.component.js